// extracted by mini-css-extract-plugin
module.exports = {"main-component":"ecosystemSvg_main-component__1GsG1"};